import * as React from 'react';
import Modal from 'antd/lib/modal';
import { LaptopOutlined } from '@ant-design/icons';
import RunwayLogo from '../../assets/runway-wordmark.svg';
import { antGrey, runwayColors } from './styles/globalStyles';

const SandboxMobileBlocker: React.FC = () => (
    <div
        style={{
            height: '100vh',
            width: '100vw',
            backgroundColor: runwayColors.lightBackgroundGrey,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
        }}
    >
        <img src={RunwayLogo} alt="Runway" style={{ marginBottom: 48 }} />
        <Modal open footer={null} closable={false} maskClosable={false} centered width={320}>
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
                <LaptopOutlined style={{ fontSize: 48, color: antGrey.grey5, marginBottom: 16, display: 'block' }} />
                <p style={{ fontSize: 16, margin: 0 }}>Visit us on a desktop browser to get started.</p>
            </div>
        </Modal>
    </div>
);

export default SandboxMobileBlocker;
